import { useContext } from 'react';
import AuthContext, { UserRole } from '../context/AuthContext';

export const useRole = () => {
    const { userRole } = useContext(AuthContext);

    const hasRole = (requiredRole: UserRole) => {
        if (!userRole) return false;
        
        if (requiredRole === 'superadmin') {
            return userRole === 'superadmin';
        }
        
        if (requiredRole === 'admin') {
            return userRole === 'admin' || userRole === 'superadmin';
        }

        if (requiredRole === 'moderator') {
            return userRole === 'moderator' || userRole === 'admin' || userRole === 'superadmin';
        }
        
        return true;
    };

    return { userRole, hasRole };
}; 